import { Col, message, Row, Typography, Upload } from "antd";
import React, { useEffect, useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import { FormItem } from "formik-antd";
import { setFileUploadIds } from "../Redux/User/reducer";

const FileUpload = ({
  uploadFile,
  userToken,
  name,
  uploadedFiles,
  getIds,
  getFileIds,
  id,
}) => {
  const [fileList, setFileList] = useState([]);
  const [showLoading, setShowLoading] = useState(false);
  useEffect(() => {
    if (uploadedFiles) {
      setFileList([...uploadedFiles]);
    } else {
      setFileList([]);
    }
  }, [uploadedFiles]);
  const props = {
    name: "files",
    action: `${process.env.REACT_APP_BASE_URL}/upload-file`,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
    multiple: true,
    showUploadList: false,
    onChange(info) {
      setShowLoading(true);
      if (info.file.status === "done") {
        message.success("File Uploaded", 3);
        const allFiles = fileList;
        const { data } = info.file.response;
        allFiles.push(data);
        setFileList([...allFiles]);
        console.log(fileList);
        setShowLoading(false);
        const fileId = data.fileId;
        if (getIds) {
          getFileIds(data);
        } else {
          uploadFile(fileId);
        }
      }
      if (info.file.status === "error") {
        message.error("Unsupported File Format");
        setShowLoading(false);
      }
    },
  };
  const filesAdded = showLoading
    ? null
    : fileList.map((eachFile, i) => (
        <Col xs={{ span: 12 }} key={i}>
          <Typography.Paragraph>
            {i + 1}. {eachFile.fileName}
          </Typography.Paragraph>
        </Col>
      ));
  return (
    <Col
      xs={{ span: 24 }}
      sm={{ span: 20 }}
      md={{ span: 20 }}
      lg={{ span: 20 }}
      xl={{ span: 24 }}
    >
      <FormItem name={name}>
        <Row style={{ marginBottom: "1vh" }}>
          <Typography.Text>Upload Files</Typography.Text>
        </Row>
        <Upload.Dragger maxCount={4} {...props} data-testid={id}>
          <InboxOutlined />
          <Row justify="center">
            <Typography.Text>Click or drag files to Upload</Typography.Text>
          </Row>
        </Upload.Dragger>
        <Row>
          {uploadedFiles ? (
            <Col>
              {uploadedFiles.length === 0 ? (
                <Row>
                  <Typography.Paragraph>
                    No Files Uploaded.
                  </Typography.Paragraph>
                </Row>
              ) : (
                <Col>{filesAdded}</Col>
              )}
            </Col>
          ) : (
            <Col>{filesAdded}</Col>
          )}
        </Row>
      </FormItem>
    </Col>
  );
};

const mapStateToProps = (state) => ({
  userToken: state.userStore.userToken,
});

const mapDispatchToProps = (dispatch) => {
  return {
    uploadFile: (fileId) => dispatch(setFileUploadIds(fileId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FileUpload);
